import { Row, Table } from '@tanstack/react-table';
import { Form } from 'react-bootstrap';

type TTableCheckboxCell = {
	table?: Table<any>;
	disabled: boolean;
	row?: Row<any>;
	'data-testid'?: string;
};

const TableCheckboxCell = ({
	table,
	disabled,
	row,
	...rest
}: TTableCheckboxCell) => {
	const getClassName = () => {
		if (disabled || !table) {
			return '';
		}

		return table.getIsAllRowsSelected() ? '' : 'line';
	};
	return (
		<div>
			<Form.Check
				disabled={disabled}
				label=""
				data-testid={rest['data-testid']}
				onChange={
					row
						? row.getToggleSelectedHandler()
						: table?.getToggleAllRowsSelectedHandler()
				}
				checked={
					row
						? row.getIsSelected()
						: table?.getIsSomeRowsSelected() || table?.getIsAllRowsSelected()
				}
				type="checkbox"
				className={getClassName()}
			/>
		</div>
	);
};
TableCheckboxCell.displayName = 'TableCheckbox';
export default TableCheckboxCell;
